import { Injectable } from '@angular/core';

import * as URI from 'urijs';

import { AppConfig } from '®shared/config';
import { WindowLocation, WindowShimService } from '®shared/window-shim';

import { WindowTarget } from './targets';

/**
 * Provides redirection to external URLs
 **/
@Injectable()
export class RedirectionService {
  constructor(
    private appConfig: AppConfig,
    private windowShim: WindowShimService,
  ) {}

  /**
   * Redirect the browser window to a given URL.
   *
   * NOTE: this is used for testing purposes.
   *
   * @param {string}          url  URL to which we should redirect.
   * @param {WindowTarget} target  The location-opening target control (e.g. `_top`)
   */
  redirectToExternalUrl(
    url: string,
    target: WindowTarget = WindowTarget.SELF,
  ): void {
    const windowWithLocation = this.windowShim.window;
    if (!url || !windowWithLocation) {
      return;
    }

    let targetLocation: WindowLocation;

    switch (target) {
      case WindowTarget.BLANK: {
        windowWithLocation.open(url);
        return;
      }
      case WindowTarget.SELF: {
        targetLocation = windowWithLocation.location;
        break;
      }
      case WindowTarget.TOP: {
        targetLocation =
          windowWithLocation.top.location || windowWithLocation.location;
        break;
      }
    }

    if (!targetLocation) {
      return;
    }

    targetLocation.href = url;
  }

  /**
   * Redirect the browser window to an error page.
   *
   * @param {string} error - The error message being rendered
   **/
  redirectToErrorPage(error: string): void {
    const baseErrorUri = new URI(this.appConfig.errorUrl());
    const errorUri = baseErrorUri.search({ error });
    this.redirectToExternalUrl(errorUri.toString());
  }
}
